'use client'

import * as React from 'react'

import { ModalWithError } from '@web/components/prod/modal-with-error'
import { Button } from '@repo/design-system-cf/components/button'
import { Typography } from '@repo/design-system-cf/components/typography'
import { useTranslations } from 'next-intl'
import { IconFileDownload, IconPerson } from '@repo/design-system-cf/components/icons'
import { useIsLoggedInQuery } from 'auth/hooks'
import { useUserAuthModal } from '@repo/user-auth-dialog/user-auth-dialog-context'
import { useDownloadLegacyProduct } from '@repo/web-ui/hooks/use-download-legacy-product'

interface GetAFreeBundleModalSuccessProps {
  isOpen: boolean
  onClose: () => void
  error?: string | null
  productId: number
}

export function GetAFreeBundleModalSuccess({
  isOpen,
  onClose,
  error = null,
  productId,
}: GetAFreeBundleModalSuccessProps) {
  const t = useTranslations('pages.daily-gifts.banner_modal_success')
  const { data: isLoggedIn } = useIsLoggedInQuery()
  const { download, isLoading } = useDownloadLegacyProduct()

  const loginModal = useUserAuthModal()

  return (
    <ModalWithError
      isOpen={isOpen}
      onClose={onClose}
      error={error}
      className="max-w-[372px] max-h-[90dvh]"
    >
      <Typography variant="cf-title-05" className="text-center mb-6">
        {t('title_modal')}
      </Typography>
      {isLoggedIn ? (
        <Typography className="mt-2 text-center">{t('description')}</Typography>
      ) : (
        <Typography className="mt-2 text-center">{t('log_in')}</Typography>
      )}

      <div className="mt-5">
        <Button
          loading={isLoading}
          disabled={isLoading}
          onClick={() => {
            if (!isLoggedIn) {
              loginModal.openModal('login')
              onClose()
              return
            }
            download({
              productId: productId.toString(),
              isFree: true,
            })
          }}
          variant={'primary-green-bright'}
          iconLeft={isLoggedIn ? <IconFileDownload /> : <IconPerson />}
          className="uppercase"
          size={'large'}
          fullWidth
        >
          {isLoggedIn ? t('cta') : t('log_in_cta')}
        </Button>
      </div>
    </ModalWithError>
  )
}
